<template>
  <div class="main_empty"
       v-if="propJson.isShow">
    <div class="shadow"
         @click="toHide()"></div>
    <div class="footer">
      <span class="logo"
            :class="{'logo_succ':propJson.status==1,'logo_ing':propJson.status==2}"></span>
      <p class="title">{{propJson.title}}</p>
      <p class="info"
         :class="{'width46':propJson.width}">{{propJson.info}}</p>
      <div class="pay_btn pay_btn_succ"
           @click="toPageUrl">{{propJson.btn}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['propJson'],
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    //跳转客户端
    toPay () {
      let json = {
        productId: this.productId,
        memberOrderSource: '1',
        scenceCode: this.scenceCode,
        memberType: this.currentMemberTypeId,
        payMoney: this.currentPayMoney,
        orderId: this.orderId,
      }
      if (this.currentPayMoney.slice(0, 1) == "￥") {
        json.payMoney = json.payMoney.slice(1)
      }
      // console.log(json)
      // if (!this.noJson) {
      //   json = {};
      // }
      if (this.currentPayWay == 36){  //0: 支付宝 1:微信
        json.payType = 0;
      }else{
        json.payType = 1;
      }
      if (this.currentPayWay == 36){
        this.$get("/app/v1.0/pay/paySelect")
                .then((res) => {
                  if (res.code == 200) {
                    let result = res.data;
                    if(result == 1){
                      try {
                        window.webkit.messageHandlers.toYsePay.postMessage(json); //ios
                      } catch (err) {
                        window.AppJs.toYsePay(JSON.stringify(json)); //android
                      }
                    }else{
                      try {
                        window.webkit.messageHandlers.toAliPay.postMessage(json); //ios
                      } catch (err) {
                        window.AppJs.toAliPay(JSON.stringify(json)); //android
                      }
                    }
                  } else {
                    this.util.toast({msg: res.message});
                  }
                })
                .catch((error) => {
                });
      }
      /*if (this.currentPayWay == 36) {//支付宝支付
        try {
          window.webkit.messageHandlers.toAliPay.postMessage(json);//ios
        } catch (err) {
          window.AppJs.toAliPay(JSON.stringify(json));//android
        }
      } else {//微信支付
        try {
          window.webkit.messageHandlers.toWexinPay.postMessage(json);//ios
        } catch (err) {
          window.AppJs.toWexinPay(JSON.stringify(json));//android
        }
      }*/
    },
    toHide () {
      this.$parent.propJson.isShow = false;
    },
    checkPay (index, item) {
      this.currentPayWay = item.page;
      this.isActive = index;
    },
    toPageUrl () {
      this.$emit("pageUrl")
      // this.$parent.propJson.isShow = false;
      // this.$router.push({
      //   path: '/loan/applyStatus',
      //   query: {
      //     orderType: 2
      //   }
      // })
    },
    toArgeement () {
      // this.$router.push({
      //   path: '/vip/agreement'
      // })
      window.location.href = "https://thread.yanhugame.com/agreement/会员服务协议.html"
    }
  }
}
</script>
<style scoped>
.main_empty {
  width: 100%;
  height: 100%;
}
.shadow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  opacity: 0.4;
  z-index: 11;
}
.color3 {
  color: #333;
}
.footer {
  position: fixed;
  top: 1.05rem;
  left: 50%;
  background: #fff;
  z-index: 111;
  width: 2.95rem;
  transform: translate(-50%, 0);
  padding-top: 0.44rem;
  border-radius: 10px;
}
.pay_btn {
  color: #ffffff;
  font-size: 0.17rem;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.5) 0%,
    rgba(81, 117, 241, 0.5) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
  margin-bottom: 0.3rem;
}
.pay_btn_succ {
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.8) 0%,
    rgba(81, 117, 241, 1) 100%
  );
}
.logo,
.logo_succ,
.logo_ing {
  display: block;
  width: 0.99rem;
  height: 0.85rem;
  background: url('../assets/img/afterLoan/rep_fail.png') no-repeat center
    center;
  background-size: 100% 100%;
  margin: 0 auto;
}
.logo_succ {
  background: url('../assets/img/afterLoan/rep_succ.png') no-repeat center
    center;
  background-size: 100% 100%;
}
.logo_ing {
  background: url('../assets/img/afterLoan/rep_ing.png') no-repeat center center;
  background-size: 100% 100%;
}
.title {
  font-size: 0.16rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 0.11rem;
}
.info {
  width: 76%;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin: 0 auto;
  text-align: center;
  margin-bottom: 0.23rem;
  line-height: 28px;
}
.width46 {
  width: 46%;
}
</style>
